import type { IVehicle } from '@makemydeal/dr-platform-types';
import { Actions } from '../actionTypes/actionTypes';

export const buyThisVehicle = (vehicle: IVehicle): any => {
    return {
        type: Actions.BUY_THIS_VEHICLE,
        payload: {
            vehicle
        }
    };
};

export const handleCancelEvent = (): any => {
    return {
        type: Actions.HANDLE_CANCEL_EVENT
    };
};

export const ddjOpened = () => ({ type: Actions.DDJ_OPENED });
